import styled from 'styled-components';

export const TooltipContent = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: #fff8ec;
  padding: 12px;
  gap: 8px;
`;

export const Title = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  color: #333333;
  font-size: 12px;
  line-height: 18px;
`;

export const Text = styled(Title)`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
